import { SA_SELLER_ID } from 'shared/consts/checkout'
import { type IState } from 'types/redux/store'
import { VOUCHER_TYPE } from 'views/consts'

/*
 * Notes:
 * - There can only be one Shop Apotheke seller!
 * - Only the seller Shop Apotheke can have the Redpoints voucher.
 */
export const redeemedRedPointsSelector = (state: IState) =>
  state.cart?.data?.sellerGroups
    .find(({ sellerId }) => sellerId === SA_SELLER_ID)
    ?.discounts.find(({ type }) => type === VOUCHER_TYPE.REDPOINTS)?.value ?? 0

export const hasSAEGroupSelector = (state: IState) =>
  state.cart?.data?.sellerGroups.some(group => group.sellerId === SA_SELLER_ID)

export const hasMPGroupSelector = (state: IState) =>
  state.cart?.data?.sellerGroups.some(group => group.sellerId !== SA_SELLER_ID)

export const isMixedGroupSelector = (state: IState) =>
  hasSAEGroupSelector(state) && hasMPGroupSelector(state)

export const hasOverdraftsSelector = (state: IState) =>
  state.cart.data.overdrafts && state.cart.data.overdrafts.length > 0

export const hasNoPurchaseHistoryOverdraftsSelector = (state: IState) =>
  state.cart?.data?.overdrafts?.some(
    obj => obj?.purchaseHistoryOverdraft === false
  )
export const maxDosageDetailsSelector = (state: IState) =>
  state.cart.data.maxDosageDetails

export const hasERxSelector = (state: IState) =>
  state.cart?.data?.sellerGroups.some(group => group.groupEntriesERx.length > 0)
